module.exports = __webpack_public_path__ + "img/8-2.d48ff83f.png";